class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        }
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = element => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl) ?
                FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
                FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {html, url}];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    }

    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove('loading');
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements =
            parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        // Sync typed_size param to input fields after AJAX reload
        syncTypedSizeInput();
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.facets-container-header-desktop', '.facets-container-header-mobile', '.facets-filters-alert-button-container'];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        })

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
            target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            }
        ]
    }

    createSearchParams(form) {
        // Before serializing, ensure typed_size is included if present in the visible input
        let typedSize = '';
        const desktopInput = document.querySelector('.search-sizes-input');
        const mobileInput = document.querySelector('.search-sizes-mobile-input');
        if (desktopInput && desktopInput.value.trim()) {
            typedSize = desktopInput.value.trim();
        } else if (mobileInput && mobileInput.value.trim()) {
            typedSize = mobileInput.value.trim();
        }
        // Remove any existing hidden typed_size input
        let hidden = form.querySelector('input[type="hidden"][name="typed_size"]');
        if (hidden) hidden.remove();
        if (typedSize) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'typed_size';
            hidden.value = typedSize;
            form.appendChild(hidden);
        }
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }
    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'))
            this.onSubmitForm(searchParams, event)
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === 'FacetFiltersFormMobile') {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join('&'), event)
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.rangeInputs = this.querySelectorAll('input[type="range"]');
        this.range = this.querySelector(".slider-price-range .progress");
        this.priceGap = 1000;
        this.minPrice = this.querySelector(".inputValues span:first-child");
        this.maxPrice = this.querySelector(".inputValues span:last-child");
        this.init();
        this.calculateProgress();
    }

    init() {
        this.rangeInputs.forEach(input => {
            input.addEventListener("input", e => {
                let minVal = parseInt(this.rangeInputs[0].value),
                    maxVal = parseInt(this.rangeInputs[1].value);
                if ((maxVal - minVal) < this.priceGap) {
                    if (e.target.classList.contains("range-min")) {
                        this.rangeInputs[0].value = maxVal - this.priceGap
                    } else {
                        this.rangeInputs[1].value = minVal + this.priceGap;
                    }
                } else {
                    this.range.style.left = ((minVal / this.rangeInputs[1].max) * 100) + "%";
                    this.range.style.right = 100 - (maxVal / this.rangeInputs[1].max) * 100 + "%";
                }

                this.minPrice.innerHTML = new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(minVal)
                this.maxPrice.innerHTML = new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(maxVal)
            });
        });
    }

    calculateProgress() {
        let minVal = parseInt(this.rangeInputs[0].value),
            maxVal = parseInt(this.rangeInputs[1].value);
        this.range.style.left = ((minVal / this.rangeInputs[1].max) * 100) + "%";
        this.range.style.right = 100 - (maxVal / this.rangeInputs[1].max) * 100 + "%";
    }
}

customElements.define('price-range', PriceRange);

class PriceRangeMob extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach(element => element.addEventListener('focusout', this.onRangeChange.bind(this)));
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range-mob', PriceRangeMob);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}

customElements.define('facet-remove', FacetRemove);

class SearchFilter extends HTMLElement {
    constructor() {
        super();
        this.searchInput = this.querySelector('.field__input');
        this.searchResults = this.closest('.parent-display').querySelectorAll('.list-menu__item');
        this.listenSearch();
    }

    listenSearch() {
        this.searchInput.addEventListener('input', (e) => {
            e.stopImmediatePropagation();
            this.filterResults(this.searchInput.value.toLowerCase())
        })
    }

    filterResults(searchValue) {
        this.searchResults.forEach(result => {
            let resultValue = result.dataset.valueHandle;
            !resultValue.includes(searchValue) ? result.classList.add('not-found') : result.classList.remove('not-found')
        })
    }
}

customElements.get('search-filter') || customElements.define('search-filter', SearchFilter);

class FilterInfoToggle {
    static openToggle = null;

    constructor() {
        this.addEventListeners();
    }

    addEventListeners() {
        document.addEventListener('click', this.handleClick.bind(this));
        document.addEventListener('click', FilterInfoToggle.closeOpenContent);
    }

    handleClick(event) {
        const infoIcon = event.target.closest('[data-filter-info-icon]');
        if (infoIcon) {
            event.preventDefault();
            event.stopPropagation();
            this.toggleInfoContent(infoIcon);
        }

        const closeButton = event.target.closest('[data-filter-info-content-close]');
        if (closeButton) {
            const content = closeButton.closest('[data-filter-info-content]');
            if (content) {
                this.hideContents(content.dataset.filterInfoContent);
            }
        }
    }

    toggleInfoContent(infoIcon) {
        const infoContentId = infoIcon.dataset.filterInfoContent;
        const infoContents = this.findInfoContents(infoContentId);

        if (FilterInfoToggle.openToggle && FilterInfoToggle.openToggle !== infoContentId) {
            this.hideContents(FilterInfoToggle.openToggle);
        }

        if (infoContents.some(content => content.style.display === 'flex')) {
            this.hideContents(infoContentId);
            FilterInfoToggle.openToggle = null;
        } else {
            this.showContents(infoContents);
            FilterInfoToggle.openToggle = infoContentId;
        }
    }

    findInfoContents(contentId) {
        return Array.from(document.querySelectorAll(`[data-filter-info-content="${contentId}"]`))
            .filter(el => el.classList.contains('filter-info_content'));
    }

    showContents(contents) {
        contents.forEach(content => {
            content.style.display = 'flex';
        });
    }

    hideContents(contentId) {
        const contents = this.findInfoContents(contentId);
        contents.forEach(content => {
            content.style.display = 'none';
        });
        FilterInfoToggle.openToggle = null;
    }

    static closeOpenContent(event) {
        if (FilterInfoToggle.openToggle) {
            const openContents = document.querySelectorAll(`[data-filter-info-content="${FilterInfoToggle.openToggle}"]`);
            const shouldClose = Array.from(openContents).every(content => !content.contains(event.target)) &&
                !event.target.closest('[data-filter-info-icon]');

            if (shouldClose) {
                FilterInfoToggle.instance.hideContents(FilterInfoToggle.openToggle);
            }
        }
    }
}

// Initialize FilterInfoToggle
document.addEventListener('DOMContentLoaded', () => {
    FilterInfoToggle.instance = new FilterInfoToggle();
});

// Helper to sync typed_size param to input fields
function syncTypedSizeInput() {
    const url = new URL(window.location.href);
    const typedSize = url.searchParams.get('typed_size');
    if (typedSize) {
        const desktopInput = document.querySelector('.search-sizes-input');
        const mobileInput = document.querySelector('.search-sizes-mobile-input');
        if (desktopInput) desktopInput.value = typedSize;
        if (mobileInput) mobileInput.value = typedSize;
    }
}

// After initial page load, sync typed_size param
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncTypedSizeInput);
} else {
    syncTypedSizeInput();
}